module.exports = __webpack_public_path__ + "img/thumb_17.d4552c63.jpg";